import $ from "jquery";
import {Draggable, gsap, InertiaPlugin} from "gsap/all";

export class AnimationSceneSelector {

  constructor({selector, onChange, onConfirm}) {
    this.$el = $(selector);
    this.onChange = onChange;
    this.onConfirm = onConfirm;
    this.init();
  }

  init() {

    // On choice change
    this.$el.find(".option").on(app.touchEvent, (e) => {
      if (gsap.isTweening(this.$el)) return;
      this.$el.find(".option").removeClass("active");
      $(e.currentTarget).addClass("active");
      this.$el.find(".confirm-button").removeClass("disabled");
      const selectedValue = $(e.currentTarget).data("option-value")
      this.$el.attr("data-selected-value", selectedValue);
      this.updateCheckbox();
      this.onChange(selectedValue)
    });

    // On choice confirm
    this.$el.find(".confirm-button").on(app.touchEvent, (e) => {
      const selectedValue = this.$el.find(".option.active").data("option-value")
      if (selectedValue) this.onConfirm(selectedValue)
    });

  }

  animateIn() {
  }

  updateCheckbox() {
    this.$el.find(".option").each((index, el) => {
      if ($(el).hasClass("active")) {
        gsap.set($("canvas", el), {scale: 1, autoAlpha: 1})
        const lottie = $(" .lottie-animation", el).data('lottie');
        lottie.setFrame(0)
        lottie.play();
      } else {
        gsap.to($("canvas", el), {autoAlpha: 0})
      }
    })
  }

  reset() {
    this.$el.find(".option").removeClass("active");
    this.$el.find(".confirm-button").addClass("disabled");
    this.$el.removeAttr("data-selected-value");
    gsap.set(this.$el.find(".option canvas"), {autoAlpha: 0})
    return this;
  }
}

